import React, { useContext, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppDataContextProvider } from '../context/AppDataContext';
import { ClientsContextProvider } from '../context/ClientsContext';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      keepPreviousData: true,
      retryOnMount: false
    }
  }
});
export const SchedulingAssistantDataStoreProvider = _ref => {
  let {
    httpClient,
    businessId = null,
    children
  } = _ref;
  useEffect(() => {
    queryClient.invalidateQueries();
    return () => {
      queryClient.invalidateQueries();
      queryClient.clear();
    };
  }, [businessId]);
  return /*#__PURE__*/React.createElement(AppDataContextProvider, {
    businessId: businessId
  }, /*#__PURE__*/React.createElement(ClientsContextProvider, {
    httpClient: httpClient
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, children)));
};
export const ChatHttpClientContext = /*#__PURE__*/React.createContext(null);
export const ChatHttpClientContextProvider = _ref2 => {
  let {
    httpClientUou,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(ChatHttpClientContext.Provider, {
    value: {
      httpClientUou
    }
  }, children);
};
export function useChatHttpClientContext() {
  const context = useContext(ChatHttpClientContext);
  if (!context) {
    throw new Error('useChatHttpClientContext must be used within ChatHttpClientContextProvider');
  }
  return context;
}
export const UoUDataStoreProvider = _ref3 => {
  let {
    httpClient,
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement(ClientsContextProvider, {
    httpClient: httpClient
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, children));
};
//# sourceMappingURL=DataStoreProvider.js.map